/* Royal Arms: knife customizer (AI theme only).
   Config: product.metafields.custom.knife_custom (rendered into #ra-knife-cfg).
   - Back Handle Color: recolors the back view of the photo (white base image x color, multiply) through a mask.
   - Engraving (Blade / Front Handle / Back Handle): draws the text on the photo, saves it as line-item properties,
     and adds one "Laser Engraving Add-On" per engraved spot to the cart. */
(function () {
  var cfgEl = document.getElementById('ra-knife-cfg');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg || !cfg.media || !cfg.text) return;

  var LIGHT = { White: 1, Grey: 1, Sand: 1 };
  var touchedBack = false;
  var imgs = {};
  function getImg(u) {
    var r = imgs[u];
    if (r) return r;
    r = imgs[u] = { img: new Image(), state: 'loading' };
    r.img.onload = function () { r.state = 'ok'; schedule(); };
    r.img.onerror = function () { r.state = 'err'; };
    r.img.src = u;
    return r;
  }
  function $(s) { return document.querySelector(s); }
  function mediaIdOf(li) { var p = (li.getAttribute('data-media-id') || '').split('-'); return p[p.length - 1]; }
  // Back Handle Color is a set of pill radio buttons (same style as the Front Handle Color picker)
  function getBack() { var r = $('input.ra-knife-back:checked'); return r ? r.value : null; }
  function setBack(v) {
    var list = document.querySelectorAll('input.ra-knife-back');
    for (var i = 0; i < list.length; i++) { if (list[i].value === v) { list[i].checked = true; return; } }
  }
  var LOGO_HEX = { White: '#f4f4f4', Gold: '#d4af37' };
  function getLogo() { var r = $('input.ra-knife-logo:checked'); return r ? r.value : 'White'; }
  function drawLogo(ctx, W, H, rect, hex) {
    var m = cfg.logo && imgs[cfg.logo];
    if (!m || m.state !== 'ok') return;
    scratch.width = W; scratch.height = H;
    var s = scratch.getContext('2d');
    s.globalCompositeOperation = 'source-over'; s.clearRect(0, 0, W, H);
    s.fillStyle = hex; s.fillRect(rect.x, rect.y, rect.w, rect.h);
    s.globalCompositeOperation = 'destination-in'; s.drawImage(m.img, rect.x, rect.y, rect.w, rect.h);
    ctx.drawImage(scratch, 0, 0);
  }
  function spots() { return Array.prototype.slice.call(document.querySelectorAll('.ra-engrave')); }
  function money(c) { return '$' + (c / 100).toFixed(2); }

  function shownFront() {
    var lis = Array.prototype.slice.call(document.querySelectorAll('media-gallery li[data-media-id]'));
    for (var i = 0; i < lis.length; i++) { var m = cfg.media[mediaIdOf(lis[i])]; if (m && lis[i].offsetParent !== null) return m; }
    for (var j = 0; j < lis.length; j++) { var m2 = cfg.media[mediaIdOf(lis[j])]; if (m2) return m2; }
    return null;
  }

  function updateTotal() {
    var n = spots().filter(function (s) { return s.value.trim(); }).length;
    var el = $('.ra-engrave-total');
    if (el) el.textContent = n ? ('Engraving: ' + n + ' x ' + money(cfg.price) + ' = +' + money(n * cfg.price)) : 'Engraving: none (' + money(cfg.price) + ' per spot)';
  }

  var scratch = document.createElement('canvas');
  function drawBack(ctx, W, H, rect, hex) {
    var base = imgs[cfg.back.base], mask = imgs[cfg.back.mask];
    if (!base || base.state !== 'ok' || !mask || mask.state !== 'ok') return false;
    scratch.width = W; scratch.height = H;
    var s = scratch.getContext('2d');
    s.globalCompositeOperation = 'source-over'; s.clearRect(0, 0, W, H);
    s.drawImage(base.img, rect.x, rect.y, rect.w, rect.h);
    s.globalCompositeOperation = 'multiply'; s.fillStyle = hex; s.fillRect(rect.x, rect.y, rect.w, rect.h);
    s.globalCompositeOperation = 'destination-in'; s.drawImage(mask.img, rect.x, rect.y, rect.w, rect.h);
    ctx.drawImage(scratch, 0, 0);
    return true;
  }
  function drawText(ctx, rect, box, txt, color) {
    var cx = rect.x + box.cx * rect.w, cy = rect.y + box.cy * rect.h;
    var w = box.w * rect.w, h = box.h * rect.h;
    var size = h * 0.95;
    ctx.save();
    ctx.translate(cx, cy); ctx.rotate(box.angle * Math.PI / 180);
    ctx.font = '700 ' + size + 'px "Arial Narrow", Arial, Helvetica, sans-serif';
    var tw = ctx.measureText(txt).width;
    if (tw > w) { size = size * w / tw; ctx.font = '700 ' + size + 'px "Arial Narrow", Arial, Helvetica, sans-serif'; }
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.shadowColor = 'rgba(0,0,0,.35)'; ctx.shadowBlur = size * 0.08; ctx.shadowOffsetY = size * 0.04;
    ctx.fillStyle = color;
    ctx.fillText(txt, 0, 0);
    ctx.restore();
  }

  function apply() {
    var front = shownFront();
    if (front && !touchedBack && getBack() !== front.color) setBack(front.color);
    updateTotal();
    var back = getBack();
    var lis = Array.prototype.slice.call(document.querySelectorAll('media-gallery li[data-media-id]'));
    lis.forEach(function (li) {
      var info = cfg.media[mediaIdOf(li)];
      var box = li.querySelector('.product__media');
      var photo = box && box.querySelector('img');
      if (!info || !box || !photo) return;
      var cv = box.querySelector(':scope > canvas.ra-kv');
      if (!cv) {
        cv = document.createElement('canvas'); cv.className = 'ra-kv'; cv.setAttribute('aria-hidden', 'true');
        cv.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:3;';
        box.appendChild(cv);
      }
      var bw = box.clientWidth, bh = box.clientHeight; if (!bw || !bh) return;
      var dpr = window.devicePixelRatio || 1, W = Math.round(bw * dpr), H = Math.round(bh * dpr);
      var nw = photo.naturalWidth || cfg.size[0], nh = photo.naturalHeight || cfg.size[1];
      var s = Math.min(W / nw, H / nh), rect = { x: (W - nw * s) / 2, y: (H - nh * s) / 2, w: nw * s, h: nh * s };
      var texts = spots().map(function (sp) { return [sp.getAttribute('data-spot'), sp.value.trim()]; });
      var logo = getLogo();
      var sig = [W, H, info.color, back, logo].concat(texts.map(function (t) { return t.join(':'); })).join('|');
      var needBack = back && back !== info.color;
      if (needBack) { getImg(cfg.back.base); getImg(cfg.back.mask); }
      if (cfg.logo) getImg(cfg.logo);
      var ready = (!needBack || (imgs[cfg.back.base].state === 'ok' && imgs[cfg.back.mask].state === 'ok')) &&
                  (!cfg.logo || imgs[cfg.logo].state === 'ok');
      if (cv.__sig === sig && ready) return;
      cv.width = W; cv.height = H;
      var ctx = cv.getContext('2d'); ctx.clearRect(0, 0, W, H);
      if (needBack) drawBack(ctx, W, H, rect, cfg.colors[back] || '#888');
      drawLogo(ctx, W, H, rect, LOGO_HEX[logo] || LOGO_HEX.White);   // clip logo: white or gold
      texts.forEach(function (t) {
        var b = cfg.text[t[0]]; if (!b || !t[1]) return;
        var handleColor = t[0].indexOf('Back') === 0 ? (back || info.color) : info.color;
        var col = b.surface === 'blade' ? 'rgba(222,222,222,.92)' : (LIGHT[handleColor] ? 'rgba(55,55,55,.88)' : 'rgba(225,225,225,.92)');
        drawText(ctx, rect, b, t[1], col);
      });
      cv.__sig = ready ? sig : null;
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return; queued = true;
    requestAnimationFrame(function () { queued = false; try { apply(); } catch (e) {} });
  }

  // ---- add engraving add-ons, then let the theme add the knife ----
  function productForm(el) {
    // note: read the id attribute — a child input named "id" shadows form.id
    return el && el.matches && el.matches('form[id^="product-form-"]') && (el.getAttribute('id') || '').indexOf('installment') === -1 && el.querySelector('[name="id"]') ? el : null;
  }
  document.addEventListener('submit', function (e) {
    var form = productForm(e.target);
    if (!form || form.__raSkip) return;
    var filled = spots().filter(function (s) { return s.value.trim(); });
    var empty = spots().filter(function (s) { return !s.value.trim(); });
    empty.forEach(function (s) { s.disabled = true; });               // don't send blank engraving fields
    setTimeout(function () { empty.forEach(function (s) { s.disabled = false; }); }, 0);
    if (!filled.length || !cfg.addon) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var qEl = document.querySelector('[name="quantity"][form="' + form.getAttribute('id') + '"]') || form.querySelector('[name="quantity"]');
    var qty = Math.max(1, parseInt(qEl && qEl.value, 10) || 1);
    var front = shownFront();
    var props = { 'Knife': (cfg.title || '') + (front ? ' - ' + front.color + ' front' : '') };
    filled.forEach(function (s) { props[s.getAttribute('data-spot')] = s.value.trim(); });
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: cfg.addon, quantity: filled.length * qty, properties: props }] })
    }).then(function (r) { return r.json(); }).catch(function () { return null; }).then(function () {
      // resubmit on a fresh task: browsers ignore a submit fired while the original one is still dispatching
      setTimeout(function () {
        empty.forEach(function (s) { s.disabled = true; });
        form.__raSkip = true;
        try { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
        finally { form.__raSkip = false; empty.forEach(function (s) { s.disabled = false; }); }
      }, 0);
    });
  }, true);

  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('ra-knife-back')) touchedBack = true;
    schedule();
  });
  document.addEventListener('input', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('ra-engrave')) schedule();
  });
  window.addEventListener('resize', schedule);
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) { var t = muts[i].target; if (t.classList && (t.classList.contains('ra-engrave-total'))) continue; schedule(); return; }
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'src'] });
  getImg(cfg.back.base); getImg(cfg.back.mask); if (cfg.logo) getImg(cfg.logo);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
})();
